module.exports = __webpack_public_path__ + "assets/images/img-078373584796b9b0f8e699968c83c0c3.png";